<footer class="footer">
  <div class="content-footer">
    <span class="title-section">
      BKUIC Todos los derechos reservados 2023. 
    </span>
  </div>
</footer>
